﻿export const ROUTES = {
  HOME: '/',
  SHOP: '/shop',
  CATEGORY: '/category/:slug',
  BRAND: '/brand/:slug',
  SUBCATEGORY: '/category/:slug/:subCategorySlug',
  PRODUCT: '/product/:slug',
  SEARCH: '/search',
  WISHLIST: '/wishlist',
  CART: '/cart',
  CHECKOUT: '/checkout',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  OTP_VERIFICATION: '/otp-verification',
  RESET_PASSWORD: '/reset-password',
  PROFILE: '/profile',
  PROFILE_DETAILS: '/profile/details',
  PROFILE_ADDRESSES: '/profile/addresses',
  PROFILE_ORDERS: '/profile/orders',
  PROFILE_ORDER_DETAIL: '/profile/orders/:id',
  PROFILE_WISHLIST: '/profile/wishlist',
  PROFILE_SETTINGS: '/profile/settings',
  ABOUT: '/about',
  FAQ: '/faq',
  PRIVACY: '/privacy-policy',
  TERMS: '/terms',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export const buildPath = {
  category: (slug: string) => `/category/${slug}`,
  brand: (slug: string) => `/brand/${slug}`,
  subcategory: (slug: string, subCategorySlug: string) => `/category/${slug}/${subCategorySlug}`,
  product: (slug: string) => `/product/${slug}`,
  orderDetail: (id: string) => `/profile/orders/${id}`,
  search: (query: string) => `/search?q=${encodeURIComponent(query)}`,
} as const;
